module.exports = __webpack_public_path__ + "static/assets/35951fe73cc2d46364a35f1be9096405.svg";